import { apiAiFrameworkCatalog } from '@modules/ai-framework/api/apiAiFrameworkCatalog'
import { apiAiFrameworkInstances } from '@modules/ai-framework/api/apiAiFrameworkInstances'

const STATUS_OK = 200
const STATUS_FORBIDDEN = 403

// Contrato spec-002 §4.3 (ui-components.md): toda action lê `r.status` do BODY
// (nunca o HTTP status — o backend responde sempre HTTP 200). Mutações de instância
// (create/edit/pause/resume/migrate) NÃO passam por aqui — são chamadas diretas dos
// modais/views via api/apiAiFrameworkInstances + dispatch('fetchInstances') no sucesso.
export const fetchCatalog = async ({ commit, dispatch }, { categoria } = {}) => {
  commit('SET_CATALOG_LOADING', true)

  const r = await apiAiFrameworkCatalog.getCatalog(categoria)

  if (r && r.status === STATUS_OK) {
    commit('SET_CATALOG', r.value || [])
  } else if (r && r.status === STATUS_FORBIDDEN) {
    commit('SET_MODULE_FORBIDDEN', true)
  } else {
    commit('SET_CATALOG', [])
    dispatch('feedback/showSnack', r, { root: true })
  }

  commit('SET_CATALOG_LOADING', false)
}

export const fetchInstances = async ({ commit, dispatch }) => {
  commit('SET_INSTANCES_LOADING', true)

  const r = await apiAiFrameworkInstances.getInstances()

  if (r && r.status === STATUS_OK) {
    commit('SET_INSTANCES', r.value || [])
  } else if (r && r.status === STATUS_FORBIDDEN) {
    commit('SET_MODULE_FORBIDDEN', true)
  } else {
    commit('SET_INSTANCES', [])
    dispatch('feedback/showSnack', r, { root: true })
  }

  commit('SET_INSTANCES_LOADING', false)
}
